import React from "react";
import SharedHelmet from './Helmet'
const TITLE = "حول موقع احسب";
const DESCRIPTION = "موقع احسب هو المنصة العربية الأكبر التي توفر أكثر من 2000 حاسبة مجانية على الإنترنت لمساعدتك في إجراء الحسابات بسرعة ودقة في مختلف المجالات مثل التمويل، اللياقة البدنية، الصحة، الرياضيات، الفيزياء، والمزيد.";
const KEYWORDS = "احسب, حاسبة, حاسبة مجانية, رياضيات, تمويل, لياقة بدنية, فيزياء, حسابات, عربية, حاسبة عبر الإنترنت";
const OG_URL = "https://do-calculate.com/ar/about/";
const About = () => {
  return (
    <div dir="rtl">
      <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="p-3 mb-2 bg-success text-white">
        <h1 style={{ fontSize: '24px', marginBottom: '15px' }}>
          <b>حول موقع "احسب"</b>
        </h1>
      </div>
      <p style={{ lineHeight: '1.6' }}>
        موقع "احسب" هو أكبر منصة عربية متخصصة في تقديم أكثر من 2000 حاسبة مجانية عبر الإنترنت. نحن نقدم مجموعة واسعة من الآلات الحاسبة التي تشمل الرياضيات، المالية، اللياقة البدنية، والصحة، والفيزياء، وغيرها. تهدف منصتنا إلى تسهيل إجراء الحسابات السريعة والدقيقة في مختلف المجالات، مع توفير معلومات متعمقة عن كل حاسبة.
        <br/>        أكثر من 92% من الآلات الحاسبة لدينا تعتمد على صيغ ومعادلات معروفة من الكتب الدراسية، مثل حاسبة  مؤشر كتلة الجسم (BMI)، وغيرها. إذا كانت الصيغ مثيرة للجدل، نقدم نتائج جميع الصيغ الشائعة، كما هو الحال في حاسبة الوزن المثالي.
        <br/>        نحن نركز بشكل حصري على توفير حاسبات سريعة وشاملة ومريحة ومجانية عبر الإنترنت في مجموعة متنوعة من المجالات. هدفنا هو أن نصبح الموقع العربي الأول الذي يلجأ إليه الناس لإجراء الحسابات السريعة. بالإضافة إلى ذلك، نؤمن بأن الإنترنت يجب أن يكون مصدرًا للمعلومات المجانية، لذا فإن جميع أدواتنا وخدماتنا مجانية تمامًا، ولا تتطلب أي تسجيل.
        <br/>        لقد بذلنا جهدًا كبيرًا للتأكد من أن جميع الحاسبات تعمل بشكل صحيح. ومع ذلك، إذا وجدت أي خطأ طفيف أو كان لديك أي اقتراحات لتحسين خدماتنا، يرجى إبلاغنا بذلك.
      </p>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        <p style={{ lineHeight: '1.6' }}>
          في حال كان لديك أي استفسار، أو ترغب من فريقنا بإضافة حاسبات جديدة، أو تود الإبلاغ عن مشكلة في إحدى الحاسبات، يرجى التواصل معنا عبر البريد الإلكتروني التالي:
          <br />
          <a href="mailto:info@do-calculate.com" style={{ color: 'white', textDecoration: 'underline' }}>info@do-calculate.com</a>
        </p>
      </div>
    </div>
  );
};
export default About;
